import { DecimalField, IntField } from '@ff-it/form';
import { TableInlines } from 'components/form/TableInlines';
import type { ReactElement, ReactNode } from 'react';

export function LengthFactors({ label }: { label: ReactNode }): ReactElement {
  return (
    <TableInlines
      name="length_steps"
      sortable={false}
      size="xs"
      headerVariant="default"
      initialValues={{ max_seconds: null, rate: null }}
      getKey={(v, _name, index) => (v.__NEW__ != null ? `n${v.__NEW__}` : `i${index}`)}
      columns={[
        {
          key: 'max_seconds',
          content: '≤ seconds',
          width: 140,
          cellProps: { textAlign: 'right' },
          render: ({ name }) => <IntField name={`${name}.max_seconds`} size="sm" className="mb-0 text-right" />,
        },
        {
          key: 'rate',
          content: label,
          width: 140,
          cellProps: { textAlign: 'right' },
          render: ({ name }) => (
            <DecimalField precision={2} name={`${name}.rate`} size="sm" className="mb-0 text-right" />
          ),
        },
      ]}
    />
  );
}
